<template>
  <div class="flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <app-logo/>
      <h2 class="text-center text-3xl leading-9 font-bold text-gray-900">
        {{$t('login.title.top')}}
      </h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="submit">
          <div>
            <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
              {{$t('login.placeholders.email')}}
            </label>
            <div class="mt-1 rounded-md">
              <fg-input v-model="form.email"
                        addon-left-icon="nc-icon nc-single-02"
                        v-validate="modelValidations.email"
                        :name="$t('login.placeholders.email')"
                        :error="getError($t('login.placeholders.email'))"
                        id="email"
                        :placeholder="$t('login.placeholders.email')">
              </fg-input>
            </div>
          </div>

          <div class="mt-2">
            <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
              {{$t('login.placeholders.password')}}
            </label>
            <div class="mt-1 rounded-md">
              <fg-input v-model="form.password"
                        addon-left-icon="nc-icon nc-key-25"
                        v-validate="modelValidations.password"
                        :name="$t('login.placeholders.password')"
                        :placeholder="$t('login.placeholders.password')"
                        :error="getError($t('login.placeholders.password'))"
                        id="password"
                        type="password">
              </fg-input>
            </div>
          </div>

          <div class="mt-6 flex items-center justify-end">
            <div class="text-sm leading-5">
              <router-link to="/forgot_password"
                           class="font-medium text-primary hover:text-primary focus:outline-none focus:underline transition ease-in-out duration-150">
                {{$t('login.forgotPassword')}}
              </router-link>
            </div>
          </div>

          <div class="mt-6">
          <span class="block w-full rounded-md shadow-sm">
            <base-button type="default"
                         native-type="submit"
                         :loading="loading"
                         block
                         class="mb-3">
              {{$t('login.submit')}}
            </base-button>
          </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import { Card } from 'src/components'
  import { entities, getRouteName, routeTypes } from 'src/config/routeTypes'
  import AppLogo from './AppLogo'

  export default {
    components: {
      AppLogo,
      Card
    },
    data () {
      return {
        loading: false,
        form: {
          email: '',
          password: ''
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
          password: {
            required: true,
            min: 6
          }
        },
      }
    },
    methods: {
      ...mapActions('user', ['login']),
      getError (name) {
        return this.errors.first(name)
      },
      async submit () {
        let result = await this.$validator.validateAll()
        if (!result) return
        try {
          this.loading = true
          await this.login(this.form)
          this.$router.push({name: getRouteName(routeTypes.LIST, entities.JOB), query: {filter: 'All'}})
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      const hasToken = localStorage.getItem('token')
      if (hasToken) {
        return next('/jobs')
      }
      localStorage.removeItem('api-host')
      next()
    }
  }
</script>
<style scoped>
  .header {
    margin-top: 0;
    margin-bottom: 15px;
  }
</style>
<style>
  .login-page.page__container .content {
    background: #102A43;
  }
</style>
